import * as Phaser from 'phaser';
import { NUTRIENTS, type NutrientKey } from '@/config/nutrients';
import { TEXTURE_KEYS } from '@/utils/textures';
import { BALANCE } from '@/config/balance';
import type { Lane } from '@/types';

const HITBOX_SIZE = 28;

export class Nutrient extends Phaser.Physics.Arcade.Image {
  private nutrientKey: NutrientKey | null = null;
  private currentLane: Lane = 1;

  constructor(scene: Phaser.Scene) {
    super(scene, 0, 0, TEXTURE_KEYS.nutrient('sua'));
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.setOrigin(0.5, 0.5);
    const body = this.body as Phaser.Physics.Arcade.Body | null;
    body?.setAllowGravity(false);
    body?.setSize(HITBOX_SIZE, HITBOX_SIZE, true);
    this.setActive(false).setVisible(false);
  }

  spawn(key: NutrientKey, lane: Lane, speed: number): void {
    const x = BALANCE.lanes.positions[lane];
    if (x === undefined) return;
    this.nutrientKey = key;
    this.currentLane = lane;
    this.setTexture(TEXTURE_KEYS.nutrient(key));
    this.setPosition(x, BALANCE.spawn.spawnY);
    this.setActive(true).setVisible(true);
    const body = this.body as Phaser.Physics.Arcade.Body | null;
    body?.setVelocity(0, speed);
    body?.setSize(HITBOX_SIZE, HITBOX_SIZE, true);
  }

  reset(): void {
    this.nutrientKey = null;
    this.setActive(false).setVisible(false);
    const body = this.body as Phaser.Physics.Arcade.Body | null;
    body?.setVelocity(0, 0);
  }

  getKey(): NutrientKey | null {
    return this.nutrientKey;
  }

  getValue(): number {
    if (!this.nutrientKey) return 0;
    return NUTRIENTS[this.nutrientKey].value;
  }

  getLane(): Lane {
    return this.currentLane;
  }

  isOutOfBounds(): boolean {
    return this.y > BALANCE.spawn.despawnY;
  }
}
